import { Home } from "@mui/icons-material";
import { Box, Breadcrumbs, IconButton, Tooltip, Typography } from "@mui/material";
import { BoxSelect } from "components";
import { BREAK_GLASS_APPROVED_EVENT } from "config/constants";
import useTranslation from "hooks/useTranslation";
import PrivateLayout from "layouts/PrivateLayout";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ThreatsTable from "./table";

export default function Threats() {
  const [boxId, setBox] = useState<string>();
  const [reloadKey, setReloadKey] = useState(0);

  const t = useTranslation();

  useEffect(() => {
    const onApproved = () => setReloadKey((k) => k + 1);
    window.addEventListener(BREAK_GLASS_APPROVED_EVENT, onApproved);
    return () => window.removeEventListener(BREAK_GLASS_APPROVED_EVENT, onApproved);
  }, []);

  return (
    <PrivateLayout canAccess={() => true}>
      <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Breadcrumbs aria-label="breadcrumb">
          <Tooltip title={t["Home"]}>
            <IconButton LinkComponent={Link} {...{ to: "/" }}>
              <Home />
            </IconButton>
          </Tooltip>
          <Typography color="text.primary">{t["Threats"]}</Typography>
        </Breadcrumbs>
        <Box maxWidth={300}>
          <BoxSelect
            value={boxId}
            onChange={(boxId) => {
              setBox(boxId);
              if (boxId) {
                localStorage.setItem("boxId", boxId);
              }
            }}
            hideLabel
          />
        </Box>
      </Box>
      <Box width="100%">
        <ThreatsTable key={reloadKey} boxId={boxId} />
      </Box>
    </PrivateLayout>
  );
}
